import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Changeset::LabeledTextArea @labelName=\"Hygi\xE8ne de vie\" @propertyName=\"lifestyle\" @changeset={{@changeset}} />", {
  moduleName: "core/components/lifestyle/edition/lifestyle-textarea/index.hbs"
});